<template>
  <a-menu-item :key="user.id">
    <router-link
      :to="{ name: 'UserOkr', params: { userId: user.id }}"
      class="menu-item"
    >
      <a-space class="space-flex">
        <UserAvatar :avatar-url="user.avatarUrl" />
        <span>{{ user.name }}</span>
      </a-space>
    </router-link>
  </a-menu-item>
</template>

<script>
import UserAvatar from '@/components/UserAvatar'

export default {
  components: {
    UserAvatar
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  }
}
</script>
